
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class RequirementStoneItemsGrid extends Serenity.EntityGrid<RequirementStoneItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.RequirementStoneItems'; }
        protected getDialogType() { return RequirementStoneItemsDialog; }
        protected getIdProperty() { return RequirementStoneItemsRow.idProperty; }
        protected getInsertPermission() { return RequirementStoneItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return RequirementStoneItemsRow.localTextPrefix; }
        protected getService() { return RequirementStoneItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

    }
}